<template>
  <div v-if="pageTotal > 0" class="ms-pagination flex-row">
    <!-- Custom thông tin summary phân trang -->
    <div v-if="multiple && textCustom" class="d-flex total-count">
      <div>{{ $t('i18nComponent.Paging.OnlyTotal') }}&nbsp;</div>
      <div class="total">
        {{ noOfSelectedRows }}/{{
          pageTotal
            ? $ms.format.formatData(pageTotal, {
                formatType: $ms.constant.FormatType.Number,
              })
            : 0
        }}
      </div>
      <span>&nbsp;{{ textCustom }}</span>
    </div>
    <div v-else class="d-flex total-count">
      <div class="total-label">
        {{ $t('i18nComponent.Paging.Total') }}
      </div>
      <div class="total">
        {{
          pageTotal
            ? $ms.format.formatData(pageTotal, {
                formatType: $ms.constant.FormatType.Number,
              })
            : 0
        }}
        <span class="text">{{ $t('i18nComponent.Paging.RecordPaging') }}</span>
      </div>
    </div>

    <!-- Combo số trang và next-prev trang -->

    <div class="flex" />
    <div v-if="invisible" class="pagination-sticky">
      <!-- <div style="color: #5f6368">
        {{ $t('i18nComponent.Paging.PageSize') }}
      </div>
      <menu-wrapper class="widget-more-container">
        <template #menu-button="{ toggleMenu }">
          <div @click="toggleMenu" class="page-size icon24">
            {{ pageSizeValue }}
          </div>
        </template>
        <template #menu-content>
          <menu-item
            v-for="item in pageSizes"
            :key="item"
            @menu-item-click="changePageSize(item)"
            >{{ item }}</menu-item
          >
        </template>
      </menu-wrapper> -->

      <ms-combobox-enum
        class="mr-2 border-color-list cbo-page-size"
        enum="Pagination"
        :init-text="
          $ms.format.formatData(pageSizeValue, {
            formatType: $ms.constant.FormatType.Enum,
            enumName: 'Pagination',
          })
        "
        :disabled="disabled"
        is-prevent-enter-text
        @selected="selectedChangePageSize"
      />

      <div :class="{disabled: disablePrevPage || disabled}" class="mr-2 btn-pointer" @click="previousPage">Trước</div>

      <button class="btn-filter mr-2" :class="{active: pageIndex == 1}" :disabled="disabled" @click="loadPageIndex(1)">
        1
      </button>
      <button v-if="pageIndex > 3" class="btn-filter style mr-2">...</button>
      <button
        v-for="p in pageIndexs"
        :key="p"
        class="btn-filter mr-2"
        :class="[{active: pageIndex == p}, {disabled: disabled}]"
        :disabled="disabled"
        @click="loadPageIndex(p)"
      >
        {{ p }}
      </button>
      <button v-if="pageIndex <= totalPages - 3" class="btn-filter style mr-2">...</button>
      <button
        v-if="totalPages > 1"
        class="btn-filter mr-2"
        :class="[
          {
            active: pageIndex == totalPages,
          },
          {disabled: disabled},
        ]"
        :disabled="disabled"
        @click="loadPageIndex(totalPages)"
      >
        {{ totalPages }}
      </button>

      <div :class="{disabled: disableNextPage || disabled}" class="btn-pointer" :disabled="disabled" @click="nextPage">
        Sau
      </div>
    </div>
  </div>
</template>
<script>
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import {useDbOptionStore} from '@/stores/dbOptionStore';
import EventBusGlobal, {GlobalEventName} from '@/commons/eventBusGlobal';

export default {
  name: 'MsPagination',
  components: {
    MenuWrapper,
    MenuItem,
  },
  props: {
    pageSize: {
      type: Number,
    },
    dataRender: {
      default: 0,
      type: Number,
    },
    /**
     * Tổng số bản ghi của dữ liệu
     */
    pageTotal: {
      default: 0,
      type: Number,
    },
    /*
    Cho phép xem tổng số
    Create: DVQUAN 21/05/2020
    */
    summary: {
      default: null,
      type: Object,
    },
    pageIndex: {
      default: 1,
      type: Number,
    },
    pagingTemplate: {},
    data: {},
    useServerSide: {
      default: false,
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    invisible: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    noOfSelectedRows: {
      type: Number,
      default: 0,
    },
    textCustom: {
      type: String,
      default: '',
    },
  },

  data() {
    const me = this;
    return {
      viewPage: me.pageIndex,
      currentPage: me.pageIndex,
      pageSizeValue: useDbOptionStore()?.state?.DefaultPageSize || me.pageSize || 20,
    };
  },
  computed: {
    // Kiểm tra hiện thị ... đầu tiên
    // Created by LTDAT (01/04/2020)

    checkFirstDotted() {
      const listFirst = [1, 2];
      return this.totalPages > 4 && listFirst.indexOf(this.viewPage) < 0 && this.viewPage > 2;
    },
    // Kiểm tra hiện thị dấu ... thứ 2
    // Created by LTDAT (01/04/2020)

    checkSecondDotted() {
      return this.totalPages > 4 && this.viewPage <= this.totalPages - 3;
    },
    /**
     * index của bản ghi cuối cùng trong trang trên tập dữ liệu trong DB
     */
    toNumberRecord() {
      return (this.pageIndex - 1) * this.pageSizeValue + this.dataRender;
    },

    /**
     * Tổng số trang theo pageSize hiện tại của grid
     */
    totalPages() {
      return Math.ceil(this.pageTotal / this.pageSizeValue);
    },

    /**
     * Bản ghi bắt đầu
     */
    fromIndex() {
      return this.dataRender == 0 ? 0 : (this.pageIndex - 1) * this.pageSizeValue + 1;
    },
    /**
     * Bản ghi bắt đầu
     */
    toIndex() {
      const value = (this.pageIndex - 1) * this.pageSizeValue + this.dataRender;
      return Math.min(value, this.pageTotal);
    },

    disableNextPage() {
      if (this.pageIndex >= this.totalPages && !this.useServerSide) {
        return true;
      }
      return false;
    },
    disablePrevPage() {
      if (this.pageIndex <= 1) {
        return true;
      }
      return false;
    },
    isShowQuantity() {
      return this.summary && this.summary.hasOwnProperty(this.quantityProp) && !this.summary.isHideQuantity;
    },
    isShowAmount() {
      return this.summary && this.summary.hasOwnProperty(this.amountProp) && !this.summary.isHideAmount;
    },

    /**
     * Mảng chứa các phần tử ở giữa nút số 1 và trang cuối cùng trong phân trang
     * CreatedBy: NXCHIEN 27.04.2022
     */
    pageIndexs: function () {
      // start là nút bắt đầu
      // end là nút kết thúc
      // ps là mảng các button nằm giữa trang đầu và trang cuối trừ 2 button ...

      // start = pageIndex - 1; start >= 2
      // end = pageIndex + 1; end <= totalPages - 1

      // pageIndex = 1 => start = end = 2;
      // pageIndex = 2 => start = 2, end = 3;
      // pageIndex = 3 => start = 2, end = 4;
      const ps = [];

      // Nếu trang hiện tại > 2 thì bắt đầu từ pageIndex - 1 còn nếu < 3 thì nút bắt đầu là 2
      const start = this.pageIndex > 2 ? this.pageIndex - 1 : 2;
      // Nút kết thúc < tổng số trang - 2 thì nút kết thúc là giá trị trang hiện tại + 1 còn nếu không thì tổng số trang - 1
      const end = this.pageIndex < this.totalPages - 2 ? this.pageIndex + 1 : this.totalPages - 1;

      // Đẩy vào mảng ps chứa các nút được phép hiển thị khi phân trang
      for (let i = start; i <= end; i++) ps.push(i);
      return ps;
    },
  },
  watch: {
    pageSizeValue: {
      handler(newVal, oldVal) {
        this.$emit('changePageSize', newVal);
      },
    },
    // Sau khi gán pagesize cần gán lại value cho pageSizeValue (đang không nhận giá trị thay đổi truyền xuống)
    pageSize: {
      handler(newVal, oldVal) {
        this.pageSizeValue = newVal;
      },
    },
  },

  created() {
    const me = this;
    me.initPageSize();
  },
  beforeUnmount() {
    const me = this;
  },

  methods: {
    initPageSize() {
      this.pageSizes = [10, 20, 50, 100];
      // let sizes = [10, 20, 50, 100],
      //   arr = [];
      // for (let i = 0; i < sizes.length; i++) {
      //   let value = sizes[i];
      //   arr.push({
      //     value: value,
      //     text: String(value),
      //   });
      // }
      // this.pageSizeSource = arr;
    },

    // Load lại page theo số trang.
    loadPageIndex(index) {
      const me = this;
      const payload = {
        skip: (index - 1) * me.pageSizeValue,
        take: me.pageSizeValue,
      };

      me.$emit('loadData', payload);
    },

    nextPage() {
      const me = this;
      if (!me.disableNextPage && !me.disabled) {
        me.loadPageIndex(this.pageIndex + 1);
      }
    },

    firstPage() {
      const me = this;
      if (!me.disablePrevPage) {
        me.loadPageIndex(1);
      }
    },

    lastPage() {
      const me = this;
      if (!me.disableNextPage) {
        me.loadPageIndex(me.totalPages);
      }
    },

    previousPage() {
      const me = this;
      if (!me.disablePrevPage && !me.disabled) {
        me.loadPageIndex(this.pageIndex - 1);
      }
    },

    changePageSize(value) {
      const dbOptions = useDbOptionStore();
      if (dbOptions?.state?.DefaultPageSize !== value) {
        dbOptions.insertUpdate({
          value_type: 1,
          DefaultPageSize: value,
        });
      }

      this.pageSizeValue = value;
      this.loadPageIndex(1);
    },

    selectedChangePageSize({newData}) {
      if (newData) {
        this.changePageSize(newData.enumValue);
      }
    },
  },

  // các sự kiện mounted
  mounted() {
    const me = this;

    // đăng ký sự kiện reload phân trang khi thay đổi trong thiết lập hiển thị
    EventBusGlobal.$on(GlobalEventName.reloadPagingSetting, () => {
      const dbOptions = useDbOptionStore();
      me.pageSizeValue = dbOptions?.state?.DefaultPageSize || 20;
    });
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/components/MsPagination.scss';
</style>
